import {NgModule} from '@angular/core';
import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './pages/login/login.component';

import { RegisterComponent } from './pages/register/register.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { Error404Component } from './pages/error404/error404.component';

import { HomeComponent } from './home/home/home.component';

import {CategoriesComponent} from './restaurant/categories/categories.component';
import {AddCategoriesComponent} from './restaurant/categories/add-categories/add-categories.component';
import {MenuItemsComponent} from './restaurant/menu-items/menu-items.component';
import {AddItemComponent} from './restaurant/menu-items/add-item/add-item.component';
import {OrdersComponent} from './restaurant/orders/orders.component';
import {ViewOrderComponent} from './restaurant/orders/view-order/view-order.component';

import {UsersComponent} from './restaurant/users/users.component';
import {AddUserComponent} from './restaurant/users/add-user/add-user.component'; 
import {ViewUserComponent} from './restaurant/users/view-user/view-users.component';

import {SettingsComponent} from './restaurant/settings/settings.component';
//for student module
import {StudentsComponent} from './restaurant/students/students.component';
import {ViewStudentComponent} from './restaurant/students/view-student/view-student.component';
import {EditStudentComponent} from './restaurant/students/edit-student/edit-student.component';
import {AddStudentComponent} from './restaurant/students/add-student/add-student.component';
//end

//notification
import {NotificationComponent} from './restaurant/notifications/notifications.component';
import {AddNotificationComponent} from './restaurant/notifications/add-notification/add-notification.component';
import {EditNotificationComponent} from './restaurant/notifications/edit-notification/edit-notification.component';
import {ViewNotificationComponent} from './restaurant/notifications/view-notification/view-notification.component';


import { ChatComponent } from './restaurant/chat/chat.component';

import {TagsComponent} from './restaurant/tags/tags.component';
import {EditTagesComponent} from './restaurant/tags/edit-tages/edit-tages.component';
import {AddTagsComponent} from './restaurant/tags/add-tags/add-tags.component';
import {BusinessInfoComponent} from './restaurant/business-info/business-info.component';
import {ProfileComponent} from './restaurant/profile/profile.component';
import {EditCategoryComponent} from './restaurant/categories/edit-category/edit-category.component';
import {ViewCategoryComponent} from './restaurant/categories/view-category/view-category.component';
import {ViewItemComponent} from './restaurant/menu-items/view-item/view-item.component';
import {EditItemComponent} from './restaurant/menu-items/edit-item/edit-item.component';
import {NewsComponent} from './restaurant/news/news.component';
import {AddNewsComponent} from './restaurant/news/add-news/add-news.component';
import {EditNewsComponent} from './restaurant/news/edit-news/edit-news.component';
import {ViewNewsComponent} from './restaurant/news/view-news/view-news.component';
import {Ng2CloudinaryModule} from 'ng2-cloudinary';
import {FileUploadModule} from 'ng2-file-upload';
import {AuthService} from './pages/login/auth.service';
import {LoginService} from './pages/login/login.service';
import {Ng2PaginationModule} from 'ng2-pagination';
import {DataTableModule} from "angular2-datatable";

import {CouponsComponent} from './restaurant/coupons/coupons.component';
import {AddCouponsComponent} from './restaurant/coupons/add-coupons/add-coupons.component';

import { PushNotificationComponent } from './restaurant/push-notification/push-notification.component';


export const routes = [
    
    {path: '', component: LoginComponent, useAsDefault: true},
    {path: 'login', component: LoginComponent},

    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: 'home', component: HomeComponent, canActivate: [AuthService]},
            { path: 'pushNotification', component: PushNotificationComponent, canActivate: [AuthService]},
            
            {
                path: 'coupons',
                children: [
                    {path: 'all', component: CouponsComponent, canActivate: [AuthService]},
                    {path: 'addCoupons', component: AddCouponsComponent, canActivate: [AuthService]}
                    
               ]
           },
    
             {
                path: 'categories',
                children: [
                    {path: 'manageCategories', component: CategoriesComponent, canActivate: [AuthService]},
                    {path: 'addCategory', component: AddCategoriesComponent, canActivate: [AuthService]},
                    {path: 'editCategory/:id', component: EditCategoryComponent, canActivate: [AuthService]},
                    {path: 'viewCategory/:id', component: ViewCategoryComponent, canActivate: [AuthService]}
                ]
            },


            {
                path: 'news',
                children: [
                    {path: 'manageNews', component: NewsComponent, canActivate: [AuthService]},
                    {path: 'addNews', component: AddNewsComponent, canActivate: [AuthService]},
                    {path: 'editNews/:id', component: EditNewsComponent, canActivate: [AuthService]},
                    {path: 'viewNews/:id', component: ViewNewsComponent, canActivate: [AuthService]}
                ]
            },
            {
                path: 'notification',
                children: [
                    {path: 'manageNotification', component: NotificationComponent, canActivate: [AuthService]},
                    {path: 'addNotification', component: AddNotificationComponent, canActivate: [AuthService]},
                    {path: 'editNotification/:id', component: EditNotificationComponent, canActivate: [AuthService]},
                    {path: 'viewNotification/:id', component: ViewNotificationComponent, canActivate: [AuthService]}
                ]
            },
            {
                path: 'order',
                children: [
                    {path: 'allOrder', component: OrdersComponent, canActivate: [AuthService]},
                    {path: 'viewOrder/:id', component: ViewOrderComponent, canActivate: [AuthService]},

                ]
            },

           {
                path: 'menu',
                children: [
                    {path: 'manageItems', component: MenuItemsComponent, canActivate: [AuthService]},
                    {path: 'addItems', component: AddItemComponent, canActivate: [AuthService]},
                    {path: 'viewItems/:id', component: ViewItemComponent, canActivate: [AuthService]},
                    {path: 'editItems/:id', component: EditItemComponent, canActivate: [AuthService]},

                ]
            },

            {
                path: 'students',
                children: [
                    {path: 'manageStudents', component: StudentsComponent, canActivate: [AuthService]},
                    {path: 'addStudent', component: AddStudentComponent, canActivate: [AuthService]},
                    {path: 'viewStudent/:id', component: ViewStudentComponent, canActivate: [AuthService]},
                    {path: 'editStudent/:id', component: EditStudentComponent, canActivate: [AuthService]},

                ]
            },

            {
                path: 'users',
                children: [
                    {path: 'manageUsers', component: UsersComponent, canActivate: [AuthService]},
                    {path: 'addUser', component: AddUserComponent, canActivate: [AuthService]},
                    {path: 'viewUser/:id', component: ViewUserComponent, canActivate: [AuthService]}

                ]
            },

            {
                path: 'tags',
                children: [
                    {path: 'all', component: TagsComponent, canActivate: [AuthService]},
                    {path: 'addTags', component: AddTagsComponent, canActivate: [AuthService]},
                    {path: 'editTags/:id', component: EditTagesComponent, canActivate: [AuthService]}
                ]

            },
            
            {path: 'chat', component: ChatComponent, canActivate: [AuthService]},

            {path: 'setting', component: SettingsComponent, canActivate: [AuthService]},

            {path: 'businessInfo', component: BusinessInfoComponent, canActivate: [AuthService]},

            {path: 'UserProfile', component: ProfileComponent, canActivate: [AuthService]},

        ] // children End
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'recover', component: RecoverComponent },
    { path: '404', component: Error404Component },

    // Not found
    { path: '**', redirectTo: '404' }

];

@NgModule({ 
providers: [
        
        AuthService,
        LoginService
    ]
})
class RestModule {
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/routes.ts